// ScriptDownloadCTA — kostenloser Skript-Download für fertige Kurse
// (ersetzt die Shop-CTA bei Kursen, deren Buch fertig ist)

import React, { useState } from 'react';
import { BookOpen, Download } from 'lucide-react';
import CourseScriptDownloadModal from './CourseScriptDownloadModal';

const ScriptDownloadCTA = ({ courseId, courseTitle, getAuthHeader }) => {
  const [open, setOpen] = useState(false);

  const shortTitle = (courseTitle || '')
    .replace(/^Weiterbildung(?:\s+zur?)?\s+/i, '')
    .replace(/^Jährliche\s+/i, '')
    .trim();

  return (
    <>
      <aside
        className="mb-8 rounded-xl overflow-hidden"
        style={{ backgroundColor: '#1B1A18' }}
        data-testid="script-download-cta"
      >
        <div className="flex items-center gap-4 sm:gap-5 px-5 sm:px-6 py-3.5">
          <BookOpen className="w-4 h-4 flex-shrink-0" style={{ color: '#8F650F' }} strokeWidth={1.7} />

          <div className="flex-1 min-w-0 flex flex-wrap items-baseline gap-x-3 gap-y-0.5">
            <span className="font-mono text-[10px] uppercase font-semibold whitespace-nowrap" style={{ letterSpacing: '0.24em', color: '#8F650F' }}>
              Skript kostenlos für dich
            </span>
            <span className="text-[13px] leading-snug truncate" style={{ color: 'rgba(245,240,234,0.75)' }}>
              Das komplette Buch zu <em className="font-display not-italic italic" style={{ color: '#F5F0EA' }}>{shortTitle}</em> als persönliches PDF-Exemplar.
            </span>
          </div>

          <button
            onClick={() => setOpen(true)}
            data-testid="free-script-download-btn"
            className="group flex-shrink-0 inline-flex items-center gap-1.5 text-[13px] font-semibold transition-opacity hover:opacity-80"
            style={{ color: '#8F650F' }}
          >
            Jetzt herunterladen
            <Download className="w-3.5 h-3.5 transition-transform group-hover:translate-y-0.5" />
          </button>
        </div>
      </aside>

      {open && (
        <CourseScriptDownloadModal
          courseId={courseId}
          courseTitle={courseTitle}
          getAuthHeader={getAuthHeader}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default ScriptDownloadCTA;
